module.exports = __webpack_public_path__ + "img/logo-light.f8bd1711.png";